import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-more\">\n  <circle cx=\"5\" cy=\"12\" r=\"2\" />\n  <circle cx=\"12\" cy=\"12\" r=\"2\" />\n  <circle cx=\"19\" cy=\"12\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol